import { Accomodation } from "../../others/accomodation.interfaces"
import Img from "../Img"
import { BsStarFill } from 'react-icons/bs'
import { Link } from "react-router-dom"
import { HeadingSkeleton, ImgSkeleton, SpanSkeleton } from "../skeletonTemplates/skeletons"

interface AccomodationCardProps extends Accomodation {
    skeleton?: boolean;
}

const AccomodationCard = ({ skeleton, ...props }: AccomodationCardProps): JSX.Element => {
    if (skeleton) return <AccomodationCardSkeleton huge={props.huge} />
    return (
        <Link
            className={`bg-white shrink-0 h-fit w-[200px] xs:w-[250px] 2xs:w-[300px] max-w-[300px] flex flex-col p-0 cursor-pointer rounded-md border-2 border-transparent ${props.huge ? 'text-lg' : ''}`}
            to={'/accomodation/' + props.name}>
            <div className="ImageContainer relative hover:brightness-75">
                <Img
                    src="/bookmark.svg"
                    alt="BookMark"
                    width={14}
                    height={18}
                    className={`absolute top-4 right-4 z-20`}
                />
                <Img
                    src={props.thumbnail + `?random=` + Math.random() * 200}
                    alt={`${props.name} thumbnail`}
                    loading="lazy"
                    className={`rounded-xl ${props.huge ? 'h-[400px]' : 'h-[220px]'} shadow brightness-75 2xs:brightness-100`}
                />
            </div>
            <div className="TextContentContainer px-4 py-2 leading-5 2xs:leading-6">
                <div className="flex gap-2 items-start justify-between w-full py-2 px-1">
                    <div className="flex flex-col">
                        <h3 className="font-medium">{props.name}</h3>
                        <span className="text-slate-400">{'Hotel'}</span>
                        <span className="text-slate-400">{props.location}</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <BsStarFill fill="#FABD3B" />
                        <span className="h-[15px] text-sm">{props.rating.rating}</span>
                    </div>

                </div>
                <div className="flex items-center gap-1">
                    <span className="text-gray-500 font-bold">{props.price.ammount} {props.price.currency} </span>
                    <sub>day</sub>
                </div>
            </div>
        </Link>
    )
}

export default AccomodationCard

export const AccomodationCardSkeleton = ({ huge }: Partial<Accomodation>): JSX.Element => {
    return (
        <div
            className={`shrink-0 flex flex-col w-[200px] xs:w-[250px] 2xs:w-[300px]  cursor-pointer rounded-md border-2 border-transparent ${huge ? 'text-lg' : ''}`} >
            <ImgSkeleton
                rounded={"rounded-md"}
                height={huge ? 400 : 220}
                width={'100%'}
            />
            <div className="px-4 py-2 leading-5 2xs:leading-6">
                <div className="flex gap-2 items-start justify-between w-full py-2">
                    <div className="flex flex-col">
                        <HeadingSkeleton />
                        <SpanSkeleton />
                    </div>
                    <div className="flex items-center gap-1">
                        <BsStarFill fill="#FABD3B" />
                        <span className="h-[15px] text-sm w-8 bg-slate-200 animate-pulse rounded">{''}</span>
                    </div>

                </div>
                <div className="flex items-center gap-1">
                    <span className="block h-2 w-8 bg-slate-200 animate-pulse rounded">{''} {''}</span>
                    <span className="block h-2 w-8 bg-slate-200 animate-pulse rounded"> </span>
                </div>
            </div>
        </div>
    )
}
